export default function Industry() {
    const $chooseTitle = jQuery('.open-desc');
    const $storiesBox = jQuery('.success-stories-box');
    const $partnersGallery = jQuery('.partners-gallery-box');
    const $ourInsightGallery = jQuery('.our-insight-box');
    const $testimonialsSlider = jQuery('.testimonials-slider');
    const $expandArrow = jQuery(".expand-arrow");
    const $techTabBoxItems = jQuery(".tech-stack-tab-box__item");
    const $modelsTabBoxItems = jQuery(".models-tab-box__item");

    this.init = () => {
        toggleDesc();
        initSlick();
        bindEvents();
    };

    const toggleDesc = () => {
        $chooseTitle.on('click', function () {
            const $this = jQuery(this);
            const $parent = $this.parent();
            const $desc = $this.next();

            $chooseTitle.not($this).parent().removeClass('active');
            $chooseTitle.not($this).next().slideUp();

            $desc.slideToggle();
            $parent.toggleClass('active');
        });
    };

    const initSlick = () => {
        if (window.matchMedia("(max-width: 768px)").matches && $storiesBox.length) {
            $storiesBox.slick({
                slidesToShow: 2,
                slidesToScroll: 2,
                autoplay: true,
                autoplaySpeed: 3000,
                dots: false,
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            prevArrow: "<div class='arrow-left'><img src='/wp-content/themes/sts/assets/images/global-icon/carousel-arrow-left.png'/> </div>",
                            nextArrow: "<div class='arrow-right'><img src='/wp-content/themes/sts/assets/images/global-icon/carousel-arrow-right.png'/> </div>",
                        }
                    }
                ]
            });
        }

        if ($partnersGallery.length) {
            $partnersGallery.slick({
                slidesToShow: 6,
                slidesToScroll: 6,
                autoplay: false,
                dots: false,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    }
                ]
            });
        }

        if ($ourInsightGallery.length) {
            $ourInsightGallery.slick({
                slidesToShow: 3,
                slidesToScroll: 3,
                autoplay: false,
                dots: false,
                arrows: true,
                variableWidth: true,
                prevArrow: "<div class='arrow-left'><img src='/wp-content/themes/sts/assets/images/global-icon/carousel-arrow-left.png'/> </div>",
                nextArrow: "<div class='arrow-right'><img src='/wp-content/themes/sts/assets/images/global-icon/carousel-arrow-right.png'/> </div>",
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    }
                ]
            });
        }

        if ($testimonialsSlider.length) {
            $testimonialsSlider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                fade: true,
                fadeSpeed: 1000,
                dots: true,
                arrows: false,
            });
        }
    };

    const bindEvents = () => {
        $expandArrow.on('click', function () {
            const $content = jQuery(this).siblings(".cutting_edge-box--item-content");
            $content.toggleClass("expanded");
            jQuery(this).css("transform", $content.hasClass("expanded") ? "rotate(180deg)" : "rotate(0deg)");
        });

        $techTabBoxItems.on('click', function () {
            $techTabBoxItems.removeClass("active");
            const id = jQuery(this).attr("data-id");
            jQuery(this).addClass("active");
            jQuery(".tech-stack-box__item").removeClass("active").filter(`[data-id=${id}]`).addClass("active");
        });

        $modelsTabBoxItems.on('click', function () {
            $modelsTabBoxItems.removeClass("active");
            const id = jQuery(this).attr("data-id");
            jQuery(this).addClass("active");
            jQuery(".models-box__item").removeClass("active").filter(`[data-id=${id}]`).addClass("active");
        });
    };
}